/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { isEmpty } from 'underscore';
import { skip, take } from 'rxjs/operators';
import { STORE_TOKEN } from 'ng/root-store/root-store.tokens';
import { selectValuesToDisplay } from 'ng/root-store/user-preferences/user-preferences.selectors';

/**
 * @ngdoc service
 * @name  MetricDataListCollDataSource
 * @description
 *     Data Source for collections built from metrics.
 */
angular.module('aviApp').factory('MetricDataListCollDataSource', [
'InventoryCollDataSource', 'Timeframe', STORE_TOKEN,
(InventoryCollDataSource, Timeframe, store) => {
    class MetricDataListCollDataSource extends InventoryCollDataSource {
        constructor(args) {
            super(args);

            store.select(selectValuesToDisplay)
                .pipe(take(1))
                .subscribe(valuesToDisplay => {
                    this.setAggregationParams_(valuesToDisplay);
                });

            this.valuesToDisplaySubscription = store.select(selectValuesToDisplay)
                .pipe(skip(1))
                .subscribe(valuesToDisplay => {
                    this.onValuesToDisplayChange_(valuesToDisplay);
                });
        }

        /**
         * @override
         */
        getRequestParams_() {
            const params = {};

            params['objectName_'] = [
                'analytics/metrics',
                'virtualservice',
                this.params_.uuid,
            ];

            params['metric_id'] = this.params_.metric_id;

            if (this.hasSearch && !isEmpty(this.searchParams_)) {
                Object.keys(this.searchParams_).forEach(key => {
                    params[key] = this.searchParams_[key];
                });
            } else if (this.params_.obj_id) {
                params['obj_id'] = this.params_.obj_id;
            }

            params['offset_'] = this.offset_;
            params['limit_'] = Math.ceil(this.limit_ * (1 + this.owner_.overLimitCoeff_ * 2));

            params['dimension_aggregation'] = this.params_.dimension_aggregation;

            if (this.params_.dimension_limit) {
                params['dimension_limit'] = this.params_.dimension_limit;
            }

            params['step'] = Timeframe.selected().step;
            params['limit'] = this.params_.limit || Timeframe.selected().limit;

            return params;
        }

        /** @override */
        onTimeframeChange_() {
            this.setStepAndLimitParams_();
            this.owner_.load(undefined, true);
        }

        /**
         * Called when valuesToDisplay of myAccount is changed.
         */
        onValuesToDisplayChange_(valuesToDisplay) {
            this.setAggregationParams_(valuesToDisplay);
            this.owner_.load(undefined, true);
        }

        /**
         * Sets params based on valuesToDisplay
         */
        setAggregationParams_(valuesToDisplay) {
            const params = {
                dimension_aggregation: undefined,
                limit: undefined,
            };

            if (valuesToDisplay === 'current') {
                params.limit = 1;
                params.dimension_aggregation = 'avg';
            } else {
                params.dimension_aggregation = valuesToDisplay;
            }

            this.setParams(params);
        }

        /** @override */
        destroy(force) {
            this.valuesToDisplaySubscription.unsubscribe();
            super.destroy(force);
        }
    }

    angular.extend(MetricDataListCollDataSource.prototype, {
        hasTotalNumberOfItems: false,
        hasSearch: false,
        hasSorting: false,
        hasPagination: true,
        defaultParams_: {},
    });

    return MetricDataListCollDataSource;
}]);
